import { Progress, Typography, Row, Col } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import { colors } from '../../../shared/styles/baseStyle';
import HomeCard from '../HomeCard';
import styles from './styles';

export default function PackageUsage() {
  const { data } = useQuery('getContractInfo');
  const { Text } = Typography;

  const percent = (
    (data.kilometers / data.currentPackageDuration) *
    100
  ).toFixed(2);
  const remaining = (data.currentPackageDuration - data.kilometers).toFixed(2);

  return (
    <HomeCard title="Χρήση Πακέτου">
      <Row justify="center" style={styles.progressContainerRow}>
        <Col>
          <Progress
            type="circle"
            percent={percent}
            strokeColor={colors.anytimeViolet}
            width={160}
            format={p => (
              <>
                <Text strong>{p}%</Text>
                <br />
                <Text type="secondary" style={styles.consumedText}>
                  καταναλωθέντα
                </Text>
              </>
            )}
          />
        </Col>
      </Row>
      <Row align="middle" style={styles.rowInfo}>
        <Col flex="none">
          <InfoCircleOutlined style={styles.infoIcon} />
        </Col>
        <Col flex="auto">
          <Text>
            Έχεις διανύσει το {percent}% των συνολικών χιλιομέτρων σου. Σου
            απομένουν ακόμα {remaining} χιλιόμετρα μέχρι τις {data.endDate}.
          </Text>
        </Col>
      </Row>
    </HomeCard>
  );
}
